// Module
var code = "<div fg-property-field-common=\"{ fieldname: true, displayname: true, placeholder: true, tooltip: false, previousfield: true }\"></div> <div fg-property-field-options></div> ";
// Exports
export default code;